
import React from 'react';
import relatedProducts from '../../../mocks/relatedProducts';

export default function RelatedProducts() {
  return (
    <section className="mt-16">
      <h3 className="text-xl font-bold text-gray-900 mb-6">관련 제품</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5" data-product-shop>
        {relatedProducts.map((product) => {
          return (
            <div
              key={product.id}
              className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-lg transition-shadow duration-300 group cursor-pointer"
            >
              <div className="relative w-full h-48 bg-gray-50 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  title={product.name}
                  className="w-full h-full object-contain p-3 group-hover:scale-105 transition-transform duration-300"
                />
                {product.badge && (
                  <span className="absolute top-3 left-3 bg-teal-600 text-white text-xs font-bold px-2 py-0.5 rounded-md">
                    {product.badge}
                  </span>
                )}
              </div>
              <div className="p-4">
                <h4 className="text-sm font-semibold text-gray-900 mb-2 line-clamp-2 leading-snug">
                  {product.name}
                </h4>
                <div className="flex items-center gap-1 mb-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < Math.floor(product.rating)
                            ? 'ri-star-fill text-yellow-400'
                            : 'ri-star-line text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                  <span className="text-xs text-gray-400">({product.reviews})</span>
                </div>
                <div className="mt-3">
                  <span className="text-base font-bold text-teal-600">
                    구매협의
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
